import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbDropdownModule, NgbNavModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { VerticalComponent } from './vertical/vertical.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchIdPipe } from './pipe/topbar.pipe';
import { CommonHeaderComponent } from './common-header/common-header.component';

@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [LayoutComponent,SearchIdPipe, SidebarComponent, TopbarComponent, FooterComponent, VerticalComponent, CommonHeaderComponent],
  imports: [
    CommonModule,
    NgbNavModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgbDropdownModule,
    ClickOutsideModule,
    // UIModule,
    SimplebarAngularModule,
    NgbModule
  ],
  providers: [
  ]
})
export class LayoutsModule { }
